import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
  faWarehouse,
  faDove,
  faEdit,
  faMapMarkerAlt,
  faLock,
  faClipboardList,
} from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import "./GranjasCarousel.css";
import { useShoppingContext } from "../../context/ShoppingContext";

const GranjasCarousel = () => {
  const {
    granjas,
    setGranjaActiva,
    galpones,
    aves,
    fetchMisGranjas,
    setShowAddAlimento,
    setShowAddControlAves,
    showAddControlAves,
  } = useShoppingContext();
  const [currentGranjaIndex, setCurrentGranjaIndex] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    fetchMisGranjas();
  }, [fetchMisGranjas]);

  useEffect(() => {
    if (granjas.length > 0) {
      setGranjaActiva(granjas[currentGranjaIndex]?.id);
    }
  }, [granjas, currentGranjaIndex, setGranjaActiva]);

  const nextGranja = () => {
    setCurrentGranjaIndex((prevIndex) =>
      prevIndex === granjas.length - 1 ? 0 : prevIndex + 1
    );
  };

  const prevGranja = () => {
    setCurrentGranjaIndex((prevIndex) =>
      prevIndex === 0 ? granjas.length - 1 : prevIndex - 1
    );
  };

  if (granjas.length === 0) {
    return <div>No hay granjas registradas</div>;
  }

  const currentGranja = granjas[currentGranjaIndex];
  const galponesEnGranja = galpones.filter(
    (galpon) => galpon.granjaId === currentGranja?.id
  );
  const numeroDeGalpones = galponesEnGranja.length;
  const avesEnGranja = aves.filter((ave) =>
    galponesEnGranja.some((galpon) => galpon.id === ave.galponId)
  );
  const numeroDeAves = avesEnGranja.reduce(
    (total, ave) => total + ave.saldo,
    0
  );

  const isVerGranjaDisabled = false;

  return (
    <>
      <div className="granja-carousel-container">
        {granjas.length > 1 && (
          <FontAwesomeIcon
            icon={faChevronLeft}
            className={`carousel-arrow ${
              currentGranjaIndex === 0 ? "arrow-disabled" : ""
            }`}
            onClick={prevGranja}
            style={{
              color: currentGranjaIndex === 0 ? "grey" : "black",
              pointerEvents: currentGranjaIndex === 0 ? "none" : "auto",
            }}
          />
        )}
        <div className="card granja-card shadow-sm">
        <button
              className="edit-btn btn-green-outline"
              onClick={() => {
                navigate(`/edit-granja/${currentGranja?.id}`);
                setGranjaActiva(currentGranja.id);
              }}
            >
              editar <FontAwesomeIcon icon={faEdit} />
            </button>
          <div className="card-body">
            <h5 className="card-title">{currentGranja?.nombre}</h5>
            <p className="card-text">
              <FontAwesomeIcon icon={faMapMarkerAlt} />{" "}
              {currentGranja?.ubicacion}
            </p>
          </div>
          <div
            className="d-flex justify-content-center w-100 mb-2"
            style={{ gap: "1rem" }}
          >
            <div className="text-center">
              <FontAwesomeIcon
                icon={faWarehouse}
                style={{ color: "#6c757d" }}
              />
              <span className="ms-1">{numeroDeGalpones}</span>
            </div>
            <div className="text-center">
              <FontAwesomeIcon
                icon={faDove}
                style={{ color: "rgb(222 208 17)" }}
              />
              <span className="ms-1">{numeroDeAves}</span>
            </div>
          </div>

          <div className={`card-footer `} style={{ gap: "1rem" }}>
            <button
              className={`btn mapIcon ${
                isVerGranjaDisabled ? "btn-secondary" : "btn-green"
              }`}
              onClick={() => {
                if (!isVerGranjaDisabled) {
                  navigate(`/mis-granjas/${currentGranja?.id}`);
                  setGranjaActiva(currentGranja.id);
                  setShowAddAlimento(false);
                }
              }}
              disabled={isVerGranjaDisabled}
            >
              <span className="size-s">
                {isVerGranjaDisabled ? "Bloqueado" : "Gestión Avícola"}
              </span>{" "}
              <FontAwesomeIcon
                icon={isVerGranjaDisabled ? faLock : faClipboardList}
              />{" "}
            </button>
            {aves.length > 0 && (
              <div
                className="reduce-add reduce"
                onClick={() => setShowAddControlAves(!showAddControlAves)}
              >
                Reducir Aves
              </div>
            )}
            
          </div>
        </div>
        {granjas.length > 1 && (
          <FontAwesomeIcon
            icon={faChevronRight}
            className={`carousel-arrow ${
              currentGranjaIndex === granjas.length - 1 ? "arrow-disabled" : ""
            }`}
            onClick={nextGranja}
            style={{
              color:
                currentGranjaIndex === granjas.length - 1 ? "grey" : "black",
              pointerEvents:
                currentGranjaIndex === granjas.length - 1 ? "none" : "auto",
            }}
          />
        )}
      </div>

    </>
  );
};

export default GranjasCarousel;
